// extracted by mini-css-extract-plugin
export default {"overflow-container":"_9KR","overflowContainer":"_9KR"};